import { useEffect } from 'react';
import TranslationScope from '../../translation/translation-scope';
import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import { Outlet } from 'react-router-dom';
import useExpandCollapse from '../../hooks/expand-collapse-hook';
import returnMethodsListStore from './stores/return-methods-list-store';
import { observer } from 'mobx-react';
import useTranslation from '../../translation/hooks/translation-hook';
import { APP_PATHS } from '../../constants/app-paths';
import TranslateButtonSPA from '../../components/translate-button/TranslateButtonSPA';


const PageOutlet: React.FC = observer(() => {
    const expandCollapseStore = useExpandCollapse();
    const {setTranslation, localeList} = useTranslation();

    useEffect(() => {
        returnMethodsListStore.load();
    }, []);

    useEffect(() => {
        const getLocalelist = () => localeList;
        returnMethodsListStore.setTranslationMethods(setTranslation, getLocalelist); 
    },[setTranslation, localeList])

    return (
        <Outlet context={expandCollapseStore} />
    );
});

const ReturnMethodsPage: React.FC = () => {   
    return (
        <TranslationScope scope="return-methods">
            <BasePageLayout title="Settings" subTitles={['Return methods']}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 0 10px 0' }}>
                    <TranslateButtonSPA path={APP_PATHS.RETURN_METHODS_LOCALIZATION}/>
                </div>

                <PageOutlet />

            </BasePageLayout>
        </TranslationScope>
    );
}

export default ReturnMethodsPage;
